import { render } from "./TwoFactorAuthenticationForm.vue?vue&type=template&id=b12d1234"
import script from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dmp/releases/1776447385/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__